import { render } from "./AddTagPopup.vue?vue&type=template&id=b379674a&scoped=true"
import script from "./AddTagPopup.vue?vue&type=script&lang=js"
export * from "./AddTagPopup.vue?vue&type=script&lang=js"

import "./AddTagPopup.vue?vue&type=style&index=0&id=b379674a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b379674a"]])

export default __exports__